// extracted by mini-css-extract-plugin
export default {"mobile":"mobile","about":"BwV5AUAr","aboutProject":"G0tByMnG","ads":"mfKiBRam"};